import { Component, Input, OnInit } from '@angular/core';
import { Member } from 'src/app/views/main/models/list-members/member';

@Component({
    selector: 'app-member-card',
    templateUrl: './member-card.component.html',
    styleUrls: ['./member-card.component.scss']
})
export class MemberCardComponent implements OnInit {
    @Input() member!: Member;
    @Input() selected = false;

    memberName = '';

    ngOnInit(): void {
        this.memberName = `${this.member.name} ${this.member.lastName}`;
    }
}

